export default "__VITE_ASSET__DHMp$UF3__"